import React from "react";
import { useI18n } from "../context/I18nContext";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../components/ui/accordion";

export default function FAQ() {
  const { t } = useI18n();
  return (
    <div>
      <section className="section border-b border-slate-200">
        <div className="container-page">
          <div className="label-divider mb-6">{t.nav.faq}</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-slate-900" data-testid="faq-title">
            {t.faq.title}
          </h1>
        </div>
      </section>

      <section className="section">
        <div className="max-w-4xl mx-auto px-6">
          <Accordion type="single" collapsible className="w-full">
            {t.faq.items.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-slate-200" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="py-6 text-left font-display text-lg font-semibold hover:no-underline" data-testid={`faq-q-${i}`}>{f.q}</AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed pb-6" data-testid={`faq-a-${i}`}>{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
